import { Layer, Source } from 'react-map-gl/maplibre';

export function LocationsSource({ id, data, visibility }) {
  return (
    <Source id={id} type="geojson" data={data} tolerance={0}>
      <Layer
        id={`${id}-fill-layer`}
        type="fill"
        layout={{
          visibility,
        }}
        paint={{
          'fill-color': '#000',
          'fill-opacity': 0.25,
        }}
      />
      <Layer
        id={`${id}-outline-layer`}
        type="line"
        layout={{
          'line-cap': 'round',
          'line-join': 'round',
          visibility,
        }}
        paint={{
          'line-color': '#fff',
          'line-width': 2,
        }}
      />
      <Layer
        id={`${id}-shape-layer`}
        type="symbol"
        layout={{
          'icon-image': 'house',
          'icon-allow-overlap': true,
          'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.125, 12, 1],
          visibility,
        }}
        paint={{
          'icon-color': '#000',
          'icon-halo-color': '#fff',
          'icon-halo-width': 1,
        }}
      />
      <Layer
        id={`${id}-symbol-layer`}
        type="symbol"
        layout={{
          'icon-image': [
            'match',
            ['get', 'type'],
            'Base',
            'base',
            'Court',
            'court',
            'Hospital',
            'hospital',
            'Police Station',
            'police-station',
            'School',
            'school',
            'Workshop',
            'workshop',
            'base',
          ],
          'icon-allow-overlap': true,
          'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.075, 12, 0.6],
          visibility,
        }}
        paint={{
          'icon-color': '#fff',
        }}
      />
    </Source>
  );
}
